import type * as React from 'react';

import { Alert } from '@gitbook/spine-react';

/**
 * Alert to display when a block is not entirelly configured or missed associated content.
 */
export function BlockMissingContentAlert(): React.ReactElement {
    return (
        <Alert
            kind="default"
            title="Oops, something is missing."
            details="We could not find the original source to display this content."
        />
    );
}
